import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { CONTACT, CV_CONFIG, ROUTES } from "./config/constants";
import "./Nav.css";

const Navbar = () => {
  const [show, setShow] = useState(false);
  const [cvText, setCvText] = useState(CV_CONFIG.defaultText);
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const handleCvClick = () => {
    setCvText(CV_CONFIG.popupText);
    setIsPopupVisible(true);

    setTimeout(() => {
      setCvText(CV_CONFIG.defaultText);
      setIsPopupVisible(false);
    }, CV_CONFIG.popupDuration);
  };

  const handleNavClick = () => {
    setShow(false);
  };

  return (
    <div className="nav-container">
      <nav className="navbar navbar-expand-md">
        <div className={`collapse navbar-collapse ${show ? "show" : ""}`} id="navbarCollapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <NavLink
                onClick={handleNavClick}
                className="nav-link"
                activeClassName="active"
                to={ROUTES.HOME}
                exact
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                onClick={handleNavClick}
                className="nav-link"
                activeClassName="active"
                to={ROUTES.PROJECTS}
              >
                Projects
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                onClick={handleNavClick}
                className="nav-link"
                activeClassName="active"
                to={ROUTES.RESUME}
              >
                Resume
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                onClick={handleNavClick}
                className="nav-link"
                activeClassName="active"
                to={CONTACT.linkedin}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-linkedin-in linkedin" aria-label="LinkedIn" />
              </NavLink>
            </li>
            <li className="nav-item">
              <div onClick={handleCvClick}>
                <button className="customButton nav-link2">{cvText} </button>
              </div>
            </li>
            <li className="nav-item">
              <a
                onClick={handleNavClick}
                className="nav-link2"
                href={`mailto:${CONTACT.email}`}
                aria-label="Send email"
              >
                <div className="customcenter">
                  <i className="fas fa-envelope" aria-hidden="true" />
                </div>
              </a>
            </li>
            <li className="nav-item">
              <NavLink
                onClick={handleNavClick}
                className="nav-link"
                activeClassName="active"
                to={CONTACT.github}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <div className="customcenter">
                  <i className="fab fa-github linkedin" aria-hidden="true"></i>
                </div>
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

Navbar.propTypes = {};

export default Navbar;